import { StyleSheet, css } from 'aphrodite'
import type React from 'react'

interface PhoneContactProps {
  phoneNumber?: string
  displayName: string
  className?: string
  iconClassName?: string
}

const PhoneContact: React.FC<PhoneContactProps> = ({
  phoneNumber,
  displayName,
  className,
  iconClassName = 'fa-solid fa-phone',
}) => {
  // If no phone number, return display name with consistent styling
  if (!phoneNumber) {
    return (
      <span className={`${css(styles.displayName)} ${className || ''}`}>
        {displayName}
      </span>
    )
  }

  // If phone number exists, return clickable link with icon
  return (
    <a
      href={`tel:${phoneNumber}`}
      className={`${css(styles.PhoneContact)} ${className || ''}`}
    >
      {displayName}
      <i className={iconClassName} style={{ marginLeft: '8px' }} />
    </a>
  )
}

const styles = StyleSheet.create({
  PhoneContact: {
    color: '#1C64F2',
    fontWeight: 600,
    fontSize: '12px',
    lineHeight: '150%',
    fontFamily: 'Inter',
    textDecoration: 'none',
    ':hover': {
      textDecoration: 'underline',
    },
  },
  displayName: {
    fontWeight: 600,
    fontSize: '12px',
    lineHeight: '150%',
    fontFamily: 'Inter',
    color: '#111827',
  },
})

export default PhoneContact
